import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as _ from 'lodash';

import { actionCreators } from '../../actionCreators';
import { deepEqual } from '../../utils';

import './styles.css';

class SidebarFleetChooser extends Component {
  componentWillReceiveProps(nextProps) {
    if (this.props.show !== nextProps.show) {
      if (nextProps.show === true) {
        this.onShow();
      } else {
        this.onHide();
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !deepEqual(this.state, nextState)
      || !deepEqual(this.props, nextProps);
  }

  onShow() {
    document.body.classList.add('toolbar-fleet-chooser-open');
  }

  onHide() {
    document.body.classList.remove('toolbar-fleet-chooser-open');
  }

  changeUserFleet(key) {
    if (key !== this.props.currentFleet) {
      this.props.dispatch(actionCreators.changeCurrentUserFleet(key));
    }

    this.props.onChoose();
  }

  close() {
    this.props.onClose();
  }

  render() {
    const fleets = _.map(this.props.fleets, (fleet, key) => ({
      $key: key,
      ...fleet,
    }));

    return (
      <div className="toolbar-fleet-chooser">
        <div className="toolbar-fleet-chooser-label">Escolha uma Operação</div>

        <div className="toolbar-fleet-chooser-body">
          <ul>
            {fleets.map(fleet => (
              <li key={fleet.$key}>
                <a
                  name={fleet.$key}
                  className={fleet.$key === this.props.currentFleet ? 'current-fleet' : undefined}
                  onClick={() => this.changeUserFleet(fleet.$key)}
                  onKeyPress={() => this.changeUserFleet(fleet.$key)}
                  tabIndex={0}
                  role="button"
                >
                  {fleet.name}
                </a>
              </li>
            ))}
          </ul>

          <div
            className={`toolbar-fleet-chooser-body-more ${this.props.currentFleet === ' _all' ? 'current-fleet' : ''}}`}
            onClick={() => this.changeUserFleet('_all')}
            onKeyPress={() => this.changeUserFleet('_all')}
            tabIndex={0}
            role="button"
          >
            Geral - Todos
          </div>
        </div>
      </div>
    );
  }
}

SidebarFleetChooser.propTypes = {
  fleets: PropTypes.object,
  currentFleet: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  show: PropTypes.bool,
  onChoose: PropTypes.func,
  onClose: PropTypes.func,
};

SidebarFleetChooser.defaultProps = {
  fleets: {},
  currentFleet: '',
  show: false,
  onChoose: () => undefined,
  onClose: () => undefined,
};

export default connect(store => ({
  fleets: store.fleetState.fleets || {},
  currentFleet: store.authState.currentUser.fleet,
}))(SidebarFleetChooser);



// WEBPACK FOOTER //
// ./src/Fleet/ToolbarFleetChoser/index.js